// eslint-disable-next-line import/no-extraneous-dependencies
import thor from '@sl/thor';

import type { TPlaceTypes } from '@/frontend/src/types/geo';
import { EPlaceTypes } from '@/frontend/src/types/geo';
import { TrackingPortal } from '@/frontend/src/types/portal';
import type { EPortal } from '@/frontend/src/types/portal';
import type { ETracking } from '@/frontend/src/types/context';

import type { TEventBody } from './customEvent';
import { EEvents, customEventService } from './customEvent';
import { APP_ENV, ENV_DEV, ENV_LIVE, ENV_PREVIEW } from './env';

export const getTrackingMedium = (
    typeKey?: TPlaceTypes | 'CannotFindMyAddress',
    tracking?: ETracking,
) => {
    if (!tracking) return;

    switch (typeKey) {
        case EPlaceTypes.Street:
            return tracking.mediumTags.streetLevel;
        case EPlaceTypes.HouseNumber:
            return tracking.mediumTags.houseNumberLevel;
        case 'CannotFindMyAddress':
            return tracking.mediumTags.cannotFindMyAddress;
        default:
            return tracking.mediumTags.noHandover;
    }
};

export const composeGeocodingPageViewPayload = ({
    portal,
    lang,
    env,
}: {
    portal: EPortal;
    lang: string;
    env: typeof APP_ENV;
}) => {
    return {
        name: 'page_view',
        data: {
            av_pagetitle: 'estimate_geocoding_form_landing',
            av_category: 'estimate',
            av_environment:
                env === ENV_LIVE
                    ? 'prod'
                    : APP_ENV === ENV_PREVIEW
                    ? 'preprod'
                    : 'staging',
            av_url_path: window.location.pathname,
            av_language: lang,
            av_site: TrackingPortal[portal],
            av_platform: 'web',
            av_initiative: 'wl_ef',
        },
    };
};

export const trackingService = {
    sendEvent: (eventPayload: TEventBody) => {
        if (eventPayload.detail) {
            thor.pushEvent(eventPayload.detail.name, eventPayload.detail.data);
        }
    },
    initTracking: () => {
        if (APP_ENV === ENV_DEV) {
            thor.checkTesting();
        }

        customEventService.subscribe(
            EEvents.SEND_PAGE_VIEW,
            trackingService.sendEvent,
        );

        return () => {
            customEventService.unsubscribe(
                EEvents.SEND_PAGE_VIEW,
                trackingService.sendEvent,
            );
        };
    },
};
